<template>
  <div class="card">
    <div>
      <v-progress-circular
        indeterminate
        color="amber"
        class="mb-5"
      ></v-progress-circular>
      <transition mode="out-in" name="fade">
        <h1>{{ randomText }}</h1>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      interval: null,
      texts: [
        "Breeding baskets are being placed...",
        "Ducklings are learning how to swim...",
        "Something is rustling in the reeds...",
        "Birdseed is being scattered...",
        "Mating rituals are being performed...",
        "Birds are bathing in the pond...",
        "A mama swan is defending her newborn...",
        "Geese are heading south...",
      ],
      randomText: null,
    };
  },
  mounted() {
    this.randomText = this.texts[Math.floor(Math.random() * this.texts.length)];
    this.interval = setInterval(() => {
      this.randomText =
        this.texts[Math.floor(Math.random() * this.texts.length)];
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style scoped>
.card {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0b3530;
  display: flex;
  justify-content: center;
  align-items: center;
}
h1 {
  font-style: normal;
  font-size: 30px;
  line-height: 77px;
  text-align: center;
  color: #f8c7ba;
  font-family: "MabryBold";
}
.fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}
</style>